// NPM
import { Link } from "gatsby"
import React from "react"

// Shared Components
import CommonLink from "src/components/Shared/CommonLink"

const SidebarLinks = ({
  productSection,
  methodology,
  sidebarLinks,
  language,
  layout = "sidebar",
  children,
}) => {
  return (
    <div className={`GenericProduct__sidebar-links layout-${layout}`}>
      <h3>
        {language === "en" ? "Links and Resources" : "Liens et ressources"}
      </h3>
      {(productSection.link || methodology) && (
        <ul>
          <li>
            <CommonLink
              link={productSection.link}
              className="GenericProduct__link"
            >
              <span className="icon">
                <img
                  src={
                    require("src/images/icons/arrow-right-white.png").default
                  }
                />
              </span>
            </CommonLink>
          </li>
          {methodology && (
            <li>
              <Link to={methodology.path} className="GenericProduct__link">
                <span>
                  {language === "en"
                    ? "View methodology"
                    : "Voir la méthodologie"}
                </span>
                <span className="icon">
                  <img
                    src={
                      require("src/images/icons/arrow-right-white.png").default
                    }
                  />
                </span>
              </Link>
            </li>
          )}
          {sidebarLinks.map(l => (
            <li key={l.url}>
              <CommonLink link={l} className="GenericProduct__link">
                <span className="icon">
                  <img
                    src={
                      require("src/images/icons/arrow-right-white.png").default
                    }
                  />
                </span>
              </CommonLink>
            </li>
          ))}
          {children}
        </ul>
      )}
    </div>
  )
}

export default SidebarLinks
